export default {
  defaultLocale: "en-US",
};



// WEBPACK FOOTER //
// ./src/config/settings.js